import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";

import { Breadcrumbs as MUIBreadcrumbs, IconButton } from "@mui/material";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { getBreadcrumbTrail } from "routes/breadcrumbRoutes";

import { employeesInfo as employeesInfoSelector } from "selectors/customerEmployees";
import { getBreadcrumbLabels } from "store/selectors/breadcrumbs";
import NavigationRoutes from "constants/NavigationRoutes";

import "./Breadcrumbs.scss";

const MAX_VISIBLE = 3;

function Breadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const employeesInfo = useSelector(employeesInfoSelector);
  const dynamicLabels = useSelector(getBreadcrumbLabels);
  const { holidayCalendarRevamp } = useFlags();

  const [expanded, setExpanded] = useState(false);

  const enhancedDynamicLabels = {
    ...dynamicLabels,
    ...(holidayCalendarRevamp && { [NavigationRoutes.holidays]: "Holiday schedule" }),
  };

  const trail = getBreadcrumbTrail(location.pathname + location.search, employeesInfo, enhancedDynamicLabels);
  const { length } = trail;
  const firstItem = trail[0];
  const lastItem = trail[length - 1];
  const showFullTrail = length <= MAX_VISIBLE || expanded;

  const handleClick = (path: string) => {
    navigate(path);
  };

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  if (showFullTrail) {
    return (
      <MUIBreadcrumbs aria-label="breadcrumb">
        {trail.map((item, idx) => {
          const { path, label } = item;
          const isLast = idx === length - 1;

          return isLast ? (
            <div key={path} className="para-body-s-regular color-text-heading-primary">
              {label}
            </div>
          ) : (
            <div
              key={path}
              className="para-body-s-regular color-text-heading-secondary"
              onClick={() => handleClick(path)}
            >
              {label}
            </div>
          );
        })}
      </MUIBreadcrumbs>
    );
  }

  const visible = [firstItem, { ...trail[length - 2], path: "more" }, lastItem];
  const [visibleFirst, , visibleLast] = visible;

  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      <div className="para-body-s-regular color-text-heading-secondary" onClick={() => handleClick(visibleFirst.path)}>
        {visibleFirst.label}
      </div>
      <IconButton size="small" onClick={toggleExpanded} className="expand-breadcrumbs-button">
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <div className="para-body-s-regular color-text-heading-primary">{visibleLast.label}</div>
    </MUIBreadcrumbs>
  );
}

export default Breadcrumbs;
